window.SHIPPING_POSTCODE_ZONES = [
    { prefix: "AB", zone: 11 },
    { prefix: "AL", zone: 7 },
    { prefix: "B", zone: 3 },
    { prefix: "BA1", zone: 7 },
    { prefix: "BA10", zone: 6 },
    { prefix: "BA11", zone: 6 },
    { prefix: "BA12", zone: 6 },
    { prefix: "BA13", zone: 6 },
    { prefix: "BA14", zone: 6 },
    { prefix: "BA15", zone: 6 },
    { prefix: "BA16", zone: 6 },
    { prefix: "BA2", zone: 7 },
    { prefix: "BA20", zone: 8 },
    { prefix: "BA21", zone: 8 },
    { prefix: "BA22", zone: 8 },
    { prefix: "BA3", zone: 6 },
    { prefix: "BA4", zone: 6 },
    { prefix: "BA5", zone: 6 },
    { prefix: "BA6", zone: 6 },
    { prefix: "BA7", zone: 6 },
    { prefix: "BA8", zone: 6 },
    { prefix: "BA9", zone: 6 },
    { prefix: "BB1", zone: 32 },
    { prefix: "BB10", zone: 4 },
    { prefix: "BB11", zone: 4 },
    { prefix: "BB12", zone: 4 },
    { prefix: "BB18", zone: 4 },
    { prefix: "BB2", zone: 32 },
    { prefix: "BB3", zone: 32 },
    { prefix: "BB4", zone: 32 },
    { prefix: "BB5", zone: 32 },
    { prefix: "BB6", zone: 32 },
    { prefix: "BB7", zone: 4 },
    { prefix: "BB8", zone: 4 },
    { prefix: "BB9", zone: 4 },
    { prefix: "BB94", zone: 32 },
    { prefix: "BD1", zone: 33 },
    { prefix: "BD10", zone: 32 },
    { prefix: "BD11", zone: 33 },
    { prefix: "BD12", zone: 33 },
    { prefix: "BD13", zone: 33 },
    { prefix: "BD14", zone: 33 },
    { prefix: "BD15", zone: 33 },
    { prefix: "BD16", zone: 33 },
    { prefix: "BD17", zone: 33 },
    { prefix: "BD18", zone: 33 },
    { prefix: "BD19", zone: 33 },
    { prefix: "BD2", zone: 32 },
    { prefix: "BD20", zone: 33 },
    { prefix: "BD21", zone: 33 },
    { prefix: "BD22", zone: 33 },
    { prefix: "BD23", zone: 34 },
    { prefix: "BD24", zone: 34 },
    { prefix: "BD3", zone: 33 },
    { prefix: "BD4", zone: 33 },
    { prefix: "BD5", zone: 33 },
    { prefix: "BD6", zone: 33 },
    { prefix: "BD7", zone: 33 },
    { prefix: "BD8", zone: 33 },
    { prefix: "BD9", zone: 33 },
    { prefix: "BD97", zone: 32 },
    { prefix: "BD98", zone: 32 },
    { prefix: "BD99", zone: 32 },
    { prefix: "BH", zone: 7 },
    { prefix: "BL0", zone: 32 },
    { prefix: "BL1", zone: 32 },
    { prefix: "BL2", zone: 32 },
    { prefix: "BL3", zone: 2 },
    { prefix: "BL4", zone: 2 },
    { prefix: "BL5", zone: 32 },
    { prefix: "BL6", zone: 32 },
    { prefix: "BL7", zone: 32 },
    { prefix: "BL78", zone: 2 },
    { prefix: "BL8", zone: 32 },
    { prefix: "BL9", zone: 2 },
    { prefix: "BN", zone: 8 },
    { prefix: "BR", zone: 8 },
    { prefix: "BS1", zone: 5 },
    { prefix: "BS10", zone: 5 },
    { prefix: "BS11", zone: 5 },
    { prefix: "BS13", zone: 6 },
    { prefix: "BS14", zone: 6 },
    { prefix: "BS15", zone: 6 },
    { prefix: "BS16", zone: 6 },
    { prefix: "BS2", zone: 5 },
    { prefix: "BS20", zone: 6 },
    { prefix: "BS21", zone: 6 },
    { prefix: "BS22", zone: 6 },
    { prefix: "BS23", zone: 6 },
    { prefix: "BS24", zone: 6 },
    { prefix: "BS25", zone: 6 },
    { prefix: "BS26", zone: 6 },
    { prefix: "BS27", zone: 6 },
    { prefix: "BS28", zone: 6 },
    { prefix: "BS29", zone: 6 },
    { prefix: "BS3", zone: 5 },
    { prefix: "BS30", zone: 6 },
    { prefix: "BS31", zone: 6 },
    { prefix: "BS32", zone: 6 },
    { prefix: "BS34", zone: 6 },
    { prefix: "BS35", zone: 6 },
    { prefix: "BS36", zone: 6 },
    { prefix: "BS37", zone: 6 },
    { prefix: "BS39", zone: 6 },
    { prefix: "BS4", zone: 5 },
    { prefix: "BS40", zone: 6 },
    { prefix: "BS41", zone: 6 },
    { prefix: "BS48", zone: 6 },
    { prefix: "BS49", zone: 6 },
    { prefix: "BS5", zone: 5 },
    { prefix: "BS6", zone: 5 },
    { prefix: "BS7", zone: 5 },
    { prefix: "BS8", zone: 5 },
    { prefix: "BS9", zone: 5 },
    { prefix: "BS98", zone: 6 },
    { prefix: "BS99", zone: 6 },
    { prefix: "BT1", zone: 16 },
    { prefix: "BT10", zone: 16 },
    { prefix: "BT11", zone: 16 },
    { prefix: "BT12", zone: 16 },
    { prefix: "BT13", zone: 16 },
    { prefix: "BT14", zone: 16 },
    { prefix: "BT15", zone: 16 },
    { prefix: "BT16", zone: 16 },
    { prefix: "BT17", zone: 16 },
    { prefix: "BT18", zone: 31 },
    { prefix: "BT19", zone: 31 },
    { prefix: "BT2", zone: 16 },
    { prefix: "BT20", zone: 31 },
    { prefix: "BT21", zone: 31 },
    { prefix: "BT22", zone: 31 },
    { prefix: "BT23", zone: 31 },
    { prefix: "BT24", zone: 31 },
    { prefix: "BT25", zone: 31 },
    { prefix: "BT26", zone: 31 },
    { prefix: "BT27", zone: 31 },
    { prefix: "BT28", zone: 31 },
    { prefix: "BT29", zone: 31 },
    { prefix: "BT3", zone: 16 },
    { prefix: "BT30", zone: 31 },
    { prefix: "BT31", zone: 31 },
    { prefix: "BT32", zone: 31 },
    { prefix: "BT33", zone: 31 },
    { prefix: "BT34", zone: 31 },
    { prefix: "BT35", zone: 31 },
    { prefix: "BT36", zone: 16 },
    { prefix: "BT37", zone: 16 },
    { prefix: "BT38", zone: 16 },
    { prefix: "BT39", zone: 16 },
    { prefix: "BT4", zone: 16 },
    { prefix: "BT40", zone: 31 },
    { prefix: "BT41", zone: 31 },
    { prefix: "BT42", zone: 31 },
    { prefix: "BT43", zone: 31 },
    { prefix: "BT44", zone: 31 },
    { prefix: "BT45", zone: 31 },
    { prefix: "BT46", zone: 31 },
    { prefix: "BT47", zone: 31 },
    { prefix: "BT48", zone: 31 },
    { prefix: "BT49", zone: 31 },
    { prefix: "BT5", zone: 16 },
    { prefix: "BT51", zone: 31 },
    { prefix: "BT52", zone: 31 },
    { prefix: "BT53", zone: 31 },
    { prefix: "BT54", zone: 31 },
    { prefix: "BT55", zone: 31 },
    { prefix: "BT56", zone: 31 },
    { prefix: "BT57", zone: 31 },
    { prefix: "BT6", zone: 16 },
    { prefix: "BT60", zone: 31 },
    { prefix: "BT61", zone: 31 },
    { prefix: "BT62", zone: 31 },
    { prefix: "BT63", zone: 31 },
    { prefix: "BT64", zone: 31 },
    { prefix: "BT65", zone: 31 },
    { prefix: "BT66", zone: 31 },
    { prefix: "BT67", zone: 31 },
    { prefix: "BT68", zone: 31 },
    { prefix: "BT69", zone: 31 },
    { prefix: "BT7", zone: 16 },
    { prefix: "BT70", zone: 31 },
    { prefix: "BT71", zone: 31 },
    { prefix: "BT74", zone: 31 },
    { prefix: "BT75", zone: 31 },
    { prefix: "BT76", zone: 31 },
    { prefix: "BT77", zone: 31 },
    { prefix: "BT78", zone: 31 },
    { prefix: "BT79", zone: 31 },
    { prefix: "BT8", zone: 16 },
    { prefix: "BT80", zone: 31 },
    { prefix: "BT81", zone: 31 },
    { prefix: "BT82", zone: 31 },
    { prefix: "BT9", zone: 16 },
    { prefix: "BT92", zone: 31 },
    { prefix: "BT93", zone: 31 },
    { prefix: "BT94", zone: 31 },
    { prefix: "CA", zone: 8 },
    { prefix: "CB1", zone: 7 },
    { prefix: "CB10", zone: 6 },
    { prefix: "CB11", zone: 6 },
    { prefix: "CB2", zone: 7 },
    { prefix: "CB21", zone: 6 },
    { prefix: "CB22", zone: 6 },
    { prefix: "CB23", zone: 6 },
    { prefix: "CB24", zone: 6 },
    { prefix: "CB25", zone: 6 },
    { prefix: "CB3", zone: 7 },
    { prefix: "CB4", zone: 7 },
    { prefix: "CB5", zone: 7 },
    { prefix: "CB6", zone: 6 },
    { prefix: "CB7", zone: 6 },
    { prefix: "CB8", zone: 6 },
    { prefix: "CB9", zone: 6 },
    { prefix: "CF10", zone: 5 },
    { prefix: "CF11", zone: 5 },
    { prefix: "CF14", zone: 5 },
    { prefix: "CF15", zone: 5 },
    { prefix: "CF23", zone: 5 },
    { prefix: "CF24", zone: 5 },
    { prefix: "CF3", zone: 5 },
    { prefix: "CF30", zone: 5 },
    { prefix: "CF31", zone: 7 },
    { prefix: "CF32", zone: 7 },
    { prefix: "CF33", zone: 7 },
    { prefix: "CF34", zone: 7 },
    { prefix: "CF35", zone: 7 },
    { prefix: "CF36", zone: 7 },
    { prefix: "CF37", zone: 5 },
    { prefix: "CF38", zone: 5 },
    { prefix: "CF39", zone: 5 },
    { prefix: "CF40", zone: 5 },
    { prefix: "CF41", zone: 7 },
    { prefix: "CF42", zone: 7 },
    { prefix: "CF43", zone: 7 },
    { prefix: "CF44", zone: 7 },
    { prefix: "CF45", zone: 7 },
    { prefix: "CF46", zone: 7 },
    { prefix: "CF47", zone: 7 },
    { prefix: "CF48", zone: 7 },
    { prefix: "CF5", zone: 5 },
    { prefix: "CF61", zone: 5 },
    { prefix: "CF62", zone: 5 },
    { prefix: "CF63", zone: 5 },
    { prefix: "CF64", zone: 5 },
    { prefix: "CF71", zone: 5 },
    { prefix: "CF72", zone: 5 },
    { prefix: "CF81", zone: 7 },
    { prefix: "CF82", zone: 7 },
    { prefix: "CF83", zone: 5 },
    { prefix: "CF91", zone: 5 },
    { prefix: "CF95", zone: 5 },
    { prefix: "CF99", zone: 5 },
    { prefix: "CH1", zone: 3 },
    { prefix: "CH2", zone: 3 },
    { prefix: "CH25", zone: 33 },
    { prefix: "CH26", zone: 33 },
    { prefix: "CH27", zone: 33 },
    { prefix: "CH28", zone: 33 },
    { prefix: "CH29", zone: 33 },
    { prefix: "CH3", zone: 3 },
    { prefix: "CH30", zone: 33 },
    { prefix: "CH31", zone: 33 },
    { prefix: "CH32", zone: 33 },
    { prefix: "CH33", zone: 33 },
    { prefix: "CH34", zone: 33 },
    { prefix: "CH4", zone: 3 },
    { prefix: "CH41", zone: 33 },
    { prefix: "CH42", zone: 33 },
    { prefix: "CH43", zone: 33 },
    { prefix: "CH44", zone: 33 },
    { prefix: "CH45", zone: 33 },
    { prefix: "CH46", zone: 33 },
    { prefix: "CH47", zone: 33 },
    { prefix: "CH48", zone: 33 },
    { prefix: "CH49", zone: 33 },
    { prefix: "CH5", zone: 3 },
    { prefix: "CH6", zone: 3 },
    { prefix: "CH60", zone: 33 },
    { prefix: "CH61", zone: 33 },
    { prefix: "CH62", zone: 33 },
    { prefix: "CH63", zone: 33 },
    { prefix: "CH64", zone: 3 },
    { prefix: "CH65", zone: 3 },
    { prefix: "CH66", zone: 3 },
    { prefix: "CH7", zone: 5 },
    { prefix: "CH70", zone: 3 },
    { prefix: "CH8", zone: 5 },
    { prefix: "CH88", zone: 33 },
    { prefix: "CH99", zone: 33 },
    { prefix: "CM", zone: 7 },
    { prefix: "CO1", zone: 7 },
    { prefix: "CO10", zone: 6 },
    { prefix: "CO11", zone: 7 },
    { prefix: "CO12", zone: 7 },
    { prefix: "CO13", zone: 7 },
    { prefix: "CO14", zone: 7 },
    { prefix: "CO15", zone: 7 },
    { prefix: "CO16", zone: 7 },
    { prefix: "CO2", zone: 7 },
    { prefix: "CO3", zone: 7 },
    { prefix: "CO4", zone: 6 },
    { prefix: "CO5", zone: 7 },
    { prefix: "CO6", zone: 6 },
    { prefix: "CO7", zone: 7 },
    { prefix: "CO8", zone: 6 },
    { prefix: "CO9", zone: 6 },
    { prefix: "CR", zone: 13 },
    { prefix: "CT", zone: 7 },
    { prefix: "CV1", zone: 3 },
    { prefix: "CV10", zone: 3 },
    { prefix: "CV11", zone: 3 },
    { prefix: "CV12", zone: 3 },
    { prefix: "CV13", zone: 3 },
    { prefix: "CV2", zone: 3 },
    { prefix: "CV21", zone: 3 },
    { prefix: "CV22", zone: 3 },
    { prefix: "CV23", zone: 3 },
    { prefix: "CV3", zone: 3 },
    { prefix: "CV31", zone: 7 },
    { prefix: "CV32", zone: 7 },
    { prefix: "CV33", zone: 7 },
    { prefix: "CV34", zone: 7 },
    { prefix: "CV35", zone: 7 },
    { prefix: "CV36", zone: 7 },
    { prefix: "CV37", zone: 7 },
    { prefix: "CV4", zone: 3 },
    { prefix: "CV47", zone: 7 },
    { prefix: "CV5", zone: 3 },
    { prefix: "CV6", zone: 3 },
    { prefix: "CV7", zone: 3 },
    { prefix: "CV8", zone: 3 },
    { prefix: "CV9", zone: 3 },
    { prefix: "CW", zone: 3 },
    { prefix: "DA1", zone: 13 },
    { prefix: "DA10", zone: 15 },
    { prefix: "DA11", zone: 15 },
    { prefix: "DA12", zone: 15 },
    { prefix: "DA13", zone: 15 },
    { prefix: "DA14", zone: 13 },
    { prefix: "DA15", zone: 13 },
    { prefix: "DA16", zone: 13 },
    { prefix: "DA17", zone: 13 },
    { prefix: "DA18", zone: 13 },
    { prefix: "DA2", zone: 15 },
    { prefix: "DA3", zone: 15 },
    { prefix: "DA4", zone: 15 },
    { prefix: "DA5", zone: 13 },
    { prefix: "DA6", zone: 13 },
    { prefix: "DA7", zone: 13 },
    { prefix: "DA8", zone: 13 },
    { prefix: "DA9", zone: 15 },
    { prefix: "DD", zone: 10 },
    { prefix: "DE1", zone: 1 },
    { prefix: "DE11", zone: 1 },
    { prefix: "DE12", zone: 1 },
    { prefix: "DE13", zone: 1 },
    { prefix: "DE14", zone: 1 },
    { prefix: "DE15", zone: 1 },
    { prefix: "DE21", zone: 1 },
    { prefix: "DE22", zone: 1 },
    { prefix: "DE23", zone: 1 },
    { prefix: "DE24", zone: 1 },
    { prefix: "DE3", zone: 1 },
    { prefix: "DE4", zone: 3 },
    { prefix: "DE45", zone: 4 },
    { prefix: "DE5", zone: 3 },
    { prefix: "DE55", zone: 3 },
    { prefix: "DE56", zone: 3 },
    { prefix: "DE6", zone: 3 },
    { prefix: "DE65", zone: 1 },
    { prefix: "DE7", zone: 3 },
    { prefix: "DE72", zone: 1 },
    { prefix: "DE73", zone: 1 },
    { prefix: "DE74", zone: 1 },
    { prefix: "DE75", zone: 3 },
    { prefix: "DE99", zone: 1 },
    { prefix: "DG1", zone: 9 },
    { prefix: "DG10", zone: 9 },
    { prefix: "DG11", zone: 9 },
    { prefix: "DG12", zone: 9 },
    { prefix: "DG13", zone: 9 },
    { prefix: "DG14", zone: 9 },
    { prefix: "DG16", zone: 9 },
    { prefix: "DG2", zone: 9 },
    { prefix: "DG3", zone: 9 },
    { prefix: "DG4", zone: 9 },
    { prefix: "DG5", zone: 9 },
    { prefix: "DG6", zone: 9 },
    { prefix: "DG7", zone: 9 },
    { prefix: "DG8", zone: 10 },
    { prefix: "DG9", zone: 10 },
    { prefix: "DH", zone: 34 },
    { prefix: "DL", zone: 34 },
    { prefix: "DN1", zone: 32 },
    { prefix: "DN10", zone: 32 },
    { prefix: "DN11", zone: 32 },
    { prefix: "DN12", zone: 32 },
    { prefix: "DN14", zone: 33 },
    { prefix: "DN15", zone: 33 },
    { prefix: "DN16", zone: 5 },
    { prefix: "DN17", zone: 33 },
    { prefix: "DN18", zone: 5 },
    { prefix: "DN19", zone: 5 },
    { prefix: "DN2", zone: 32 },
    { prefix: "DN20", zone: 5 },
    { prefix: "DN21", zone: 5 },
    { prefix: "DN22", zone: 32 },
    { prefix: "DN3", zone: 32 },
    { prefix: "DN31", zone: 5 },
    { prefix: "DN32", zone: 5 },
    { prefix: "DN33", zone: 5 },
    { prefix: "DN34", zone: 5 },
    { prefix: "DN35", zone: 5 },
    { prefix: "DN36", zone: 5 },
    { prefix: "DN37", zone: 5 },
    { prefix: "DN38", zone: 5 },
    { prefix: "DN39", zone: 5 },
    { prefix: "DN4", zone: 32 },
    { prefix: "DN40", zone: 5 },
    { prefix: "DN41", zone: 5 },
    { prefix: "DN5", zone: 32 },
    { prefix: "DN55", zone: 32 },
    { prefix: "DN6", zone: 32 },
    { prefix: "DN7", zone: 32 },
    { prefix: "DN8", zone: 33 },
    { prefix: "DN9", zone: 33 },
    { prefix: "DT1", zone: 9 },
    { prefix: "DT10", zone: 8 },
    { prefix: "DT11", zone: 8 },
    { prefix: "DT2", zone: 9 },
    { prefix: "DT3", zone: 9 },
    { prefix: "DT4", zone: 9 },
    { prefix: "DT5", zone: 9 },
    { prefix: "DT6", zone: 9 },
    { prefix: "DT7", zone: 9 },
    { prefix: "DT8", zone: 9 },
    { prefix: "DT9", zone: 8 },
    { prefix: "DY", zone: 3 },
    { prefix: "E1", zone: 30 },
    { prefix: "E10", zone: 29 },
    { prefix: "E11", zone: 29 },
    { prefix: "E12", zone: 29 },
    { prefix: "E13", zone: 29 },
    { prefix: "E14", zone: 30 },
    { prefix: "E15", zone: 29 },
    { prefix: "E16", zone: 29 },
    { prefix: "E17", zone: 29 },
    { prefix: "E18", zone: 29 },
    { prefix: "E2", zone: 29 },
    { prefix: "E20", zone: 29 },
    { prefix: "E3", zone: 29 },
    { prefix: "E4", zone: 29 },
    { prefix: "E5", zone: 29 },
    { prefix: "E6", zone: 29 },
    { prefix: "E7", zone: 29 },
    { prefix: "E8", zone: 29 },
    { prefix: "E9", zone: 29 },
    { prefix: "E98", zone: 29 },
    { prefix: "EC", zone: 30 },
    { prefix: "EH", zone: 9 },
    { prefix: "EN", zone: 7 },
    { prefix: "EX", zone: 9 },
    { prefix: "FK1", zone: 9 },
    { prefix: "FK10", zone: 9 },
    { prefix: "FK11", zone: 10 },
    { prefix: "FK12", zone: 10 },
    { prefix: "FK13", zone: 10 },
    { prefix: "FK14", zone: 10 },
    { prefix: "FK15", zone: 10 },
    { prefix: "FK16", zone: 10 },
    { prefix: "FK17", zone: 10 },
    { prefix: "FK18", zone: 10 },
    { prefix: "FK19", zone: 10 },
    { prefix: "FK2", zone: 9 },
    { prefix: "FK20", zone: 10 },
    { prefix: "FK21", zone: 10 },
    { prefix: "FK3", zone: 9 },
    { prefix: "FK4", zone: 9 },
    { prefix: "FK5", zone: 9 },
    { prefix: "FK6", zone: 9 },
    { prefix: "FK7", zone: 9 },
    { prefix: "FK8", zone: 10 },
    { prefix: "FK9", zone: 10 },
    { prefix: "FY", zone: 34 },
    { prefix: "G", zone: 9 },
    { prefix: "GL1", zone: 6 },
    { prefix: "GL10", zone: 6 },
    { prefix: "GL11", zone: 6 },
    { prefix: "GL12", zone: 6 },
    { prefix: "GL13", zone: 6 },
    { prefix: "GL14", zone: 6 },
    { prefix: "GL15", zone: 6 },
    { prefix: "GL16", zone: 6 },
    { prefix: "GL17", zone: 6 },
    { prefix: "GL18", zone: 6 },
    { prefix: "GL19", zone: 6 },
    { prefix: "GL2", zone: 6 },
    { prefix: "GL20", zone: 6 },
    { prefix: "GL3", zone: 6 },
    { prefix: "GL4", zone: 6 },
    { prefix: "GL5", zone: 6 },
    { prefix: "GL50", zone: 6 },
    { prefix: "GL51", zone: 6 },
    { prefix: "GL52", zone: 6 },
    { prefix: "GL53", zone: 6 },
    { prefix: "GL54", zone: 6 },
    { prefix: "GL55", zone: 6 },
    { prefix: "GL56", zone: 6 },
    { prefix: "GL6", zone: 6 },
    { prefix: "GL7", zone: 7 },
    { prefix: "GL8", zone: 6 },
    { prefix: "GL9", zone: 6 },
    { prefix: "GU1", zone: 7 },
    { prefix: "GY1", zone: 27 },
    { prefix: "GY2", zone: 27 },
    { prefix: "GY3", zone: 27 },
    { prefix: "GY4", zone: 27 },
    { prefix: "GY5", zone: 27 },
    { prefix: "GY6", zone: 27 },
    { prefix: "GY7", zone: 27 },
    { prefix: "GY8", zone: 27 },
    { prefix: "GY9", zone: 28 },
    { prefix: "GY10", zone: 28 },
    { prefix: "HA", zone: 6 },
    { prefix: "HD", zone: 32 },
    { prefix: "HG", zone: 33 },
    { prefix: "HP", zone: 7 },
    { prefix: "HR", zone: 6 },
    { prefix: "HS", zone: 21 },
    { prefix: "HU", zone: 33 },
    { prefix: "HX", zone: 33 },
    { prefix: "IG", zone: 13 },
    { prefix: "IM", zone: 26 },
    { prefix: "IP1", zone: 6 },
    { prefix: "IP10", zone: 6 },
    { prefix: "IP11", zone: 6 },
    { prefix: "IP12", zone: 24 },
    { prefix: "IP13", zone: 24 },
    { prefix: "IP14", zone: 24 },
    { prefix: "IP15", zone: 24 },
    { prefix: "IP16", zone: 24 },
    { prefix: "IP17", zone: 24 },
    { prefix: "IP18", zone: 24 },
    { prefix: "IP19", zone: 24 },
    { prefix: "IP2", zone: 6 },
    { prefix: "IP20", zone: 24 },
    { prefix: "IP21", zone: 24 },
    { prefix: "IP22", zone: 24 },
    { prefix: "IP23", zone: 24 },
    { prefix: "IP24", zone: 6 },
    { prefix: "IP25", zone: 6 },
    { prefix: "IP26", zone: 6 },
    { prefix: "IP27", zone: 6 },
    { prefix: "IP28", zone: 6 },
    { prefix: "IP29", zone: 6 },
    { prefix: "IP3", zone: 6 },
    { prefix: "IP30", zone: 6 },
    { prefix: "IP31", zone: 6 },
    { prefix: "IP32", zone: 6 },
    { prefix: "IP33", zone: 6 },
    { prefix: "IP4", zone: 6 },
    { prefix: "IP5", zone: 6 },
    { prefix: "IP6", zone: 6 },
    { prefix: "IP7", zone: 6 },
    { prefix: "IP8", zone: 6 },
    { prefix: "IP9", zone: 6 },
    { prefix: "IP98", zone: 6 },
    { prefix: "IV1", zone: 11 },
    { prefix: "IV10", zone: 11 },
    { prefix: "IV11", zone: 11 },
    { prefix: "IV12", zone: 11 },
    { prefix: "IV13", zone: 11 },
    { prefix: "IV14", zone: 11 },
    { prefix: "IV15", zone: 11 },
    { prefix: "IV16", zone: 11 },
    { prefix: "IV17", zone: 11 },
    { prefix: "IV18", zone: 11 },
    { prefix: "IV19", zone: 11 },
    { prefix: "IV2", zone: 11 },
    { prefix: "IV20", zone: 11 },
    { prefix: "IV21", zone: 11 },
    { prefix: "IV22", zone: 11 },
    { prefix: "IV23", zone: 11 },
    { prefix: "IV24", zone: 11 },
    { prefix: "IV25", zone: 11 },
    { prefix: "IV26", zone: 11 },
    { prefix: "IV27", zone: 11 },
    { prefix: "IV28", zone: 11 },
    { prefix: "IV3", zone: 11 },
    { prefix: "IV30", zone: 11 },
    { prefix: "IV31", zone: 11 },
    { prefix: "IV32", zone: 11 },
    { prefix: "IV36", zone: 11 },
    { prefix: "IV4", zone: 11 },
    { prefix: "IV40", zone: 19 },
    { prefix: "IV41", zone: 19 },
    { prefix: "IV42", zone: 19 },
    { prefix: "IV43", zone: 19 },
    { prefix: "IV44", zone: 19 },
    { prefix: "IV45", zone: 19 },
    { prefix: "IV46", zone: 19 },
    { prefix: "IV47", zone: 19 },
    { prefix: "IV48", zone: 19 },
    { prefix: "IV49", zone: 19 },
    { prefix: "IV5", zone: 11 },
    { prefix: "IV51", zone: 19 },
    { prefix: "IV52", zone: 19 },
    { prefix: "IV53", zone: 19 },
    { prefix: "IV54", zone: 19 },
    { prefix: "IV55", zone: 11 },
    { prefix: "IV56", zone: 11 },
    { prefix: "IV6", zone: 11 },
    { prefix: "IV63", zone: 11 },
    { prefix: "IV7", zone: 11 },
    { prefix: "IV8", zone: 11 },
    { prefix: "IV9", zone: 11 },
    { prefix: "IV99", zone: 11 },
    { prefix: "JE", zone: 27 },
    { prefix: "KA1", zone: 9 },
    { prefix: "KA10", zone: 9 },
    { prefix: "KA11", zone: 9 },
    { prefix: "KA12", zone: 9 },
    { prefix: "KA13", zone: 9 },
    { prefix: "KA14", zone: 9 },
    { prefix: "KA15", zone: 9 },
    { prefix: "KA16", zone: 9 },
    { prefix: "KA17", zone: 9 },
    { prefix: "KA18", zone: 9 },
    { prefix: "KA19", zone: 9 },
    { prefix: "KA2", zone: 9 },
    { prefix: "KA20", zone: 9 },
    { prefix: "KA21", zone: 9 },
    { prefix: "KA22", zone: 9 },
    { prefix: "KA23", zone: 9 },
    { prefix: "KA24", zone: 9 },
    { prefix: "KA25", zone: 9 },
    { prefix: "KA26", zone: 9 },
    { prefix: "KA27", zone: 24 },
    { prefix: "KA28", zone: 24 },
    { prefix: "KA29", zone: 9 },
    { prefix: "KA3", zone: 9 },
    { prefix: "KA30", zone: 9 },
    { prefix: "KA4", zone: 9 },
    { prefix: "KA5", zone: 9 },
    { prefix: "KA6", zone: 9 },
    { prefix: "KA7", zone: 9 },
    { prefix: "KA8", zone: 9 },
    { prefix: "KA9", zone: 9 },
    { prefix: "KT", zone: 8 },
    { prefix: "KW1", zone: 11 },
    { prefix: "KW10", zone: 11 },
    { prefix: "KW11", zone: 11 },
    { prefix: "KW12", zone: 11 },
    { prefix: "KW13", zone: 11 },
    { prefix: "KW14", zone: 11 },
    { prefix: "KW15", zone: 20 },
    { prefix: "KW16", zone: 20 },
    { prefix: "KW17", zone: 20 },
    { prefix: "KW2", zone: 11 },
    { prefix: "KW3", zone: 11 },
    { prefix: "KW5", zone: 11 },
    { prefix: "KW6", zone: 11 },
    { prefix: "KW7", zone: 11 },
    { prefix: "KW8", zone: 11 },
    { prefix: "KW9", zone: 11 },
    { prefix: "KY1", zone: 10 },
    { prefix: "KY10", zone: 10 },
    { prefix: "KY11", zone: 10 },
    { prefix: "KY12", zone: 10 },
    { prefix: "KY13", zone: 10 },
    { prefix: "KY14", zone: 10 },
    { prefix: "KY15", zone: 10 },
    { prefix: "KY16", zone: 10 },
    { prefix: "KY2", zone: 9 },
    { prefix: "KY3", zone: 9 },
    { prefix: "KY4", zone: 9 },
    { prefix: "KY5", zone: 9 },
    { prefix: "KY6", zone: 10 },
    { prefix: "KY7", zone: 10 },
    { prefix: "KY8", zone: 10 },
    { prefix: "KY9", zone: 10 },
    { prefix: "KY99", zone: 10 },
    { prefix: "L", zone: 32 },
    { prefix: "LA1", zone: 6 },
    { prefix: "LA10", zone: 6 },
    { prefix: "LA11", zone: 7 },
    { prefix: "LA12", zone: 7 },
    { prefix: "LA13", zone: 7 },
    { prefix: "LA14", zone: 7 },
    { prefix: "LA15", zone: 7 },
    { prefix: "LA16", zone: 7 },
    { prefix: "LA17", zone: 7 },
    { prefix: "LA18", zone: 7 },
    { prefix: "LA19", zone: 7 },
    { prefix: "LA2", zone: 6 },
    { prefix: "LA20", zone: 7 },
    { prefix: "LA21", zone: 7 },
    { prefix: "LA22", zone: 7 },
    { prefix: "LA23", zone: 7 },
    { prefix: "LA3", zone: 6 },
    { prefix: "LA4", zone: 6 },
    { prefix: "LA5", zone: 6 },
    { prefix: "LA6", zone: 6 },
    { prefix: "LA7", zone: 6 },
    { prefix: "LA8", zone: 6 },
    { prefix: "LA9", zone: 6 },
    { prefix: "LD", zone: 9 },
    { prefix: "LE", zone: 3 },
    { prefix: "LL11", zone: 5 },
    { prefix: "LL12", zone: 5 },
    { prefix: "LL13", zone: 5 },
    { prefix: "LL14", zone: 5 },
    { prefix: "LL15", zone: 8 },
    { prefix: "LL16", zone: 8 },
    { prefix: "LL17", zone: 8 },
    { prefix: "LL18", zone: 8 },
    { prefix: "LL19", zone: 8 },
    { prefix: "LL20", zone: 8 },
    { prefix: "LL21", zone: 8 },
    { prefix: "LL22", zone: 8 },
    { prefix: "LL23", zone: 8 },
    { prefix: "LL24", zone: 8 },
    { prefix: "LL25", zone: 8 },
    { prefix: "LL26", zone: 8 },
    { prefix: "LL27", zone: 8 },
    { prefix: "LL28", zone: 8 },
    { prefix: "LL29", zone: 8 },
    { prefix: "LL30", zone: 8 },
    { prefix: "LL31", zone: 8 },
    { prefix: "LL32", zone: 8 },
    { prefix: "LL33", zone: 8 },
    { prefix: "LL34", zone: 8 },
    { prefix: "LL35", zone: 9 },
    { prefix: "LL36", zone: 9 },
    { prefix: "LL37", zone: 9 },
    { prefix: "LL38", zone: 9 },
    { prefix: "LL39", zone: 9 },
    { prefix: "LL40", zone: 9 },
    { prefix: "LL41", zone: 9 },
    { prefix: "LL42", zone: 9 },
    { prefix: "LL43", zone: 9 },
    { prefix: "LL44", zone: 9 },
    { prefix: "LL45", zone: 9 },
    { prefix: "LL46", zone: 9 },
    { prefix: "LL47", zone: 9 },
    { prefix: "LL48", zone: 9 },
    { prefix: "LL49", zone: 9 },
    { prefix: "LL51", zone: 9 },
    { prefix: "LL52", zone: 9 },
    { prefix: "LL53", zone: 9 },
    { prefix: "LL54", zone: 9 },
    { prefix: "LL55", zone: 9 },
    { prefix: "LL56", zone: 9 },
    { prefix: "LL57", zone: 8 },
    { prefix: "LL58", zone: 9 },
    { prefix: "LL59", zone: 9 },
    { prefix: "LL60", zone: 9 },
    { prefix: "LL61", zone: 9 },
    { prefix: "LL62", zone: 9 },
    { prefix: "LL63", zone: 9 },
    { prefix: "LL64", zone: 9 },
    { prefix: "LL65", zone: 9 },
    { prefix: "LL66", zone: 9 },
    { prefix: "LL67", zone: 9 },
    { prefix: "LL68", zone: 9 },
    { prefix: "LL69", zone: 9 },
    { prefix: "LL70", zone: 9 },
    { prefix: "LL71", zone: 9 },
    { prefix: "LL72", zone: 9 },
    { prefix: "LL73", zone: 9 },
    { prefix: "LL74", zone: 9 },
    { prefix: "LL75", zone: 9 },
    { prefix: "LL76", zone: 9 },
    { prefix: "LL77", zone: 9 },
    { prefix: "LL78", zone: 9 },
    { prefix: "LN1", zone: 5 },
    { prefix: "LN10", zone: 6 },
    { prefix: "LN11", zone: 6 },
    { prefix: "LN12", zone: 6 },
    { prefix: "LN13", zone: 6 },
    { prefix: "LN2", zone: 5 },
    { prefix: "LN3", zone: 5 },
    { prefix: "LN4", zone: 5 },
    { prefix: "LN5", zone: 5 },
    { prefix: "LN6", zone: 5 },
    { prefix: "LN7", zone: 5 },
    { prefix: "LN8", zone: 5 },
    { prefix: "LN9", zone: 6 },
    { prefix: "LS1", zone: 2 },
    { prefix: "LS10", zone: 2 },
    { prefix: "LS11", zone: 2 },
    { prefix: "LS12", zone: 2 },
    { prefix: "LS13", zone: 2 },
    { prefix: "LS14", zone: 2 },
    { prefix: "LS15", zone: 2 },
    { prefix: "LS16", zone: 2 },
    { prefix: "LS17", zone: 2 },
    { prefix: "LS18", zone: 2 },
    { prefix: "LS19", zone: 2 },
    { prefix: "LS2", zone: 2 },
    { prefix: "LS20", zone: 2 },
    { prefix: "LS21", zone: 2 },
    { prefix: "LS22", zone: 32 },
    { prefix: "LS23", zone: 32 },
    { prefix: "LS24", zone: 32 },
    { prefix: "LS25", zone: 2 },
    { prefix: "LS26", zone: 2 },
    { prefix: "LS27", zone: 2 },
    { prefix: "LS28", zone: 2 },
    { prefix: "LS29", zone: 2 },
    { prefix: "LS3", zone: 2 },
    { prefix: "LS4", zone: 2 },
    { prefix: "LS5", zone: 2 },
    { prefix: "LS6", zone: 2 },
    { prefix: "LS7", zone: 2 },
    { prefix: "LS8", zone: 2 },
    { prefix: "LS88", zone: 2 },
    { prefix: "LS9", zone: 2 },
    { prefix: "LS98", zone: 2 },
    { prefix: "LS99", zone: 2 },
    { prefix: "LU", zone: 7 },
    { prefix: "M1", zone: 2 },
    { prefix: "M11", zone: 2 },
    { prefix: "M12", zone: 2 },
    { prefix: "M13", zone: 2 },
    { prefix: "M14", zone: 2 },
    { prefix: "M15", zone: 2 },
    { prefix: "M16", zone: 2 },
    { prefix: "M17", zone: 2 },
    { prefix: "M18", zone: 2 },
    { prefix: "M19", zone: 2 },
    { prefix: "M2", zone: 2 },
    { prefix: "M20", zone: 3 },
    { prefix: "M21", zone: 2 },
    { prefix: "M22", zone: 3 },
    { prefix: "M23", zone: 3 },
    { prefix: "M24", zone: 2 },
    { prefix: "M25", zone: 2 },
    { prefix: "M26", zone: 2 },
    { prefix: "M27", zone: 2 },
    { prefix: "M28", zone: 3 },
    { prefix: "M29", zone: 3 },
    { prefix: "M3", zone: 2 },
    { prefix: "M30", zone: 3 },
    { prefix: "M31", zone: 3 },
    { prefix: "M32", zone: 2 },
    { prefix: "M33", zone: 3 },
    { prefix: "M34", zone: 2 },
    { prefix: "M35", zone: 2 },
    { prefix: "M38", zone: 3 },
    { prefix: "M4", zone: 2 },
    { prefix: "M40", zone: 2 },
    { prefix: "M41", zone: 3 },
    { prefix: "M43", zone: 2 },
    { prefix: "M44", zone: 3 },
    { prefix: "M45", zone: 2 },
    { prefix: "M46", zone: 3 },
    { prefix: "M5", zone: 2 },
    { prefix: "M50", zone: 2 },
    { prefix: "M6", zone: 2 },
    { prefix: "M60", zone: 2 },
    { prefix: "M61", zone: 2 },
    { prefix: "M7", zone: 2 },
    { prefix: "M8", zone: 2 },
    { prefix: "M9", zone: 2 },
    { prefix: "M90", zone: 3 },
    { prefix: "M99", zone: 2 },
    { prefix: "ME", zone: 7 },
    { prefix: "MK1", zone: 5 },
    { prefix: "MK10", zone: 5 },
    { prefix: "MK11", zone: 5 },
    { prefix: "MK12", zone: 5 },
    { prefix: "MK13", zone: 5 },
    { prefix: "MK14", zone: 5 },
    { prefix: "MK15", zone: 5 },
    { prefix: "MK16", zone: 6 },
    { prefix: "MK17", zone: 5 },
    { prefix: "MK18", zone: 5 },
    { prefix: "MK19", zone: 5 },
    { prefix: "MK2", zone: 5 },
    { prefix: "MK3", zone: 5 },
    { prefix: "MK4", zone: 5 },
    { prefix: "MK40", zone: 7 },
    { prefix: "MK41", zone: 7 },
    { prefix: "MK42", zone: 7 },
    { prefix: "MK43", zone: 6 },
    { prefix: "MK44", zone: 7 },
    { prefix: "MK45", zone: 7 },
    { prefix: "MK46", zone: 6 },
    { prefix: "MK5", zone: 5 },
    { prefix: "MK6", zone: 5 },
    { prefix: "MK7", zone: 5 },
    { prefix: "MK77", zone: 5 },
    { prefix: "MK8", zone: 5 },
    { prefix: "MK9", zone: 5 },
    { prefix: "ML", zone: 9 },
    { prefix: "N1", zone: 30 },
    { prefix: "N10", zone: 29 },
    { prefix: "N11", zone: 13 },
    { prefix: "N12", zone: 13 },
    { prefix: "N13", zone: 13 },
    { prefix: "N14", zone: 13 },
    { prefix: "N15", zone: 29 },
    { prefix: "N16", zone: 29 },
    { prefix: "N17", zone: 29 },
    { prefix: "N18", zone: 29 },
    { prefix: "N19", zone: 29 },
    { prefix: "N2", zone: 29 },
    { prefix: "N20", zone: 13 },
    { prefix: "N21", zone: 13 },
    { prefix: "N22", zone: 29 },
    { prefix: "N3", zone: 13 },
    { prefix: "N4", zone: 29 },
    { prefix: "N5", zone: 29 },
    { prefix: "N6", zone: 29 },
    { prefix: "N7", zone: 29 },
    { prefix: "N8", zone: 29 },
    { prefix: "N81", zone: 13 },
    { prefix: "N9", zone: 13 },
    { prefix: "NE", zone: 34 },
    { prefix: "NG", zone: 3 },
    { prefix: "NN", zone: 3 },
    { prefix: "NP10", zone: 5 },
    { prefix: "NP11", zone: 7 },
    { prefix: "NP12", zone: 7 },
    { prefix: "NP13", zone: 7 },
    { prefix: "NP15", zone: 7 },
    { prefix: "NP16", zone: 7 },
    { prefix: "NP18", zone: 5 },
    { prefix: "NP19", zone: 5 },
    { prefix: "NP20", zone: 5 },
    { prefix: "NP22", zone: 7 },
    { prefix: "NP23", zone: 7 },
    { prefix: "NP24", zone: 7 },
    { prefix: "NP25", zone: 7 },
    { prefix: "NP26", zone: 5 },
    { prefix: "NP4", zone: 7 },
    { prefix: "NP44", zone: 5 },
    { prefix: "NP7", zone: 7 },
    { prefix: "NP8", zone: 7 },
    { prefix: "NR1", zone: 14 },
    { prefix: "NR10", zone: 14 },
    { prefix: "NR11", zone: 7 },
    { prefix: "NR12", zone: 7 },
    { prefix: "NR13", zone: 14 },
    { prefix: "NR14", zone: 14 },
    { prefix: "NR15", zone: 14 },
    { prefix: "NR16", zone: 14 },
    { prefix: "NR17", zone: 14 },
    { prefix: "NR18", zone: 14 },
    { prefix: "NR19", zone: 14 },
    { prefix: "NR2", zone: 14 },
    { prefix: "NR20", zone: 14 },
    { prefix: "NR21", zone: 14 },
    { prefix: "NR22", zone: 14 },
    { prefix: "NR23", zone: 14 },
    { prefix: "NR24", zone: 7 },
    { prefix: "NR25", zone: 7 },
    { prefix: "NR26", zone: 7 },
    { prefix: "NR27", zone: 7 },
    { prefix: "NR28", zone: 7 },
    { prefix: "NR29", zone: 14 },
    { prefix: "NR3", zone: 14 },
    { prefix: "NR30", zone: 14 },
    { prefix: "NR31", zone: 14 },
    { prefix: "NR32", zone: 14 },
    { prefix: "NR33", zone: 14 },
    { prefix: "NR34", zone: 14 },
    { prefix: "NR35", zone: 14 },
    { prefix: "NR4", zone: 14 },
    { prefix: "NR5", zone: 14 },
    { prefix: "NR6", zone: 14 },
    { prefix: "NR7", zone: 14 },
    { prefix: "NR8", zone: 14 },
    { prefix: "NR9", zone: 14 },
    { prefix: "NR99", zone: 14 },
    { prefix: "NW1", zone: 30 },
    { prefix: "NW10", zone: 13 },
    { prefix: "NW11", zone: 13 },
    { prefix: "NW1W", zone: 13 },
    { prefix: "NW2", zone: 13 },
    { prefix: "NW26", zone: 13 },
    { prefix: "NW3", zone: 29 },
    { prefix: "NW4", zone: 13 },
    { prefix: "NW5", zone: 29 },
    { prefix: "NW6", zone: 29 },
    { prefix: "NW7", zone: 13 },
    { prefix: "NW8", zone: 29 },
    { prefix: "NW9", zone: 13 },
    { prefix: "OL1", zone: 2 },
    { prefix: "OL10", zone: 2 },
    { prefix: "OL11", zone: 2 },
    { prefix: "OL12", zone: 32 },
    { prefix: "OL13", zone: 4 },
    { prefix: "OL14", zone: 4 },
    { prefix: "OL15", zone: 32 },
    { prefix: "OL16", zone: 32 },
    { prefix: "OL2", zone: 2 },
    { prefix: "OL3", zone: 2 },
    { prefix: "OL4", zone: 2 },
    { prefix: "OL5", zone: 2 },
    { prefix: "OL6", zone: 2 },
    { prefix: "OL7", zone: 2 },
    { prefix: "OL8", zone: 2 },
    { prefix: "OL9", zone: 2 },
    { prefix: "OL95", zone: 2 },
    { prefix: "OX", zone: 7 },
    { prefix: "PA1", zone: 9 },
    { prefix: "PA10", zone: 9 },
    { prefix: "PA11", zone: 9 },
    { prefix: "PA12", zone: 9 },
    { prefix: "PA13", zone: 9 },
    { prefix: "PA14", zone: 9 },
    { prefix: "PA15", zone: 9 },
    { prefix: "PA16", zone: 9 },
    { prefix: "PA17", zone: 9 },
    { prefix: "PA18", zone: 9 },
    { prefix: "PA19", zone: 9 },
    { prefix: "PA2", zone: 9 },
    { prefix: "PA20", zone: 21 },
    { prefix: "PA21", zone: 23 },
    { prefix: "PA22", zone: 23 },
    { prefix: "PA23", zone: 23 },
    { prefix: "PA24", zone: 23 },
    { prefix: "PA25", zone: 23 },
    { prefix: "PA26", zone: 23 },
    { prefix: "PA27", zone: 23 },
    { prefix: "PA28", zone: 23 },
    { prefix: "PA29", zone: 23 },
    { prefix: "PA3", zone: 9 },
    { prefix: "PA30", zone: 23 },
    { prefix: "PA31", zone: 23 },
    { prefix: "PA32", zone: 23 },
    { prefix: "PA33", zone: 23 },
    { prefix: "PA34", zone: 23 },
    { prefix: "PA35", zone: 23 },
    { prefix: "PA36", zone: 23 },
    { prefix: "PA37", zone: 23 },
    { prefix: "PA38", zone: 23 },
    { prefix: "PA4", zone: 9 },
    { prefix: "PA41", zone: 24 },
    { prefix: "PA42", zone: 24 },
    { prefix: "PA43", zone: 24 },
    { prefix: "PA44", zone: 24 },
    { prefix: "PA45", zone: 24 },
    { prefix: "PA46", zone: 24 },
    { prefix: "PA47", zone: 24 },
    { prefix: "PA48", zone: 24 },
    { prefix: "PA49", zone: 24 },
    { prefix: "PA5", zone: 9 },
    { prefix: "PA6", zone: 9 },
    { prefix: "PA60", zone: 24 },
    { prefix: "PA61", zone: 24 },
    { prefix: "PA62", zone: 24 },
    { prefix: "PA63", zone: 24 },
    { prefix: "PA64", zone: 24 },
    { prefix: "PA65", zone: 24 },
    { prefix: "PA66", zone: 24 },
    { prefix: "PA67", zone: 24 },
    { prefix: "PA68", zone: 24 },
    { prefix: "PA69", zone: 24 },
    { prefix: "PA7", zone: 9 },
    { prefix: "PA70", zone: 24 },
    { prefix: "PA71", zone: 24 },
    { prefix: "PA72", zone: 24 },
    { prefix: "PA73", zone: 24 },
    { prefix: "PA74", zone: 24 },
    { prefix: "PA75", zone: 24 },
    { prefix: "PA76", zone: 24 },
    { prefix: "PA77", zone: 24 },
    { prefix: "PA78", zone: 24 },
    { prefix: "PA8", zone: 9 },
    { prefix: "PA80", zone: 24 },
    { prefix: "PA9", zone: 9 },
    { prefix: "PE1", zone: 4 },
    { prefix: "PE10", zone: 4 },
    { prefix: "PE11", zone: 4 },
    { prefix: "PE12", zone: 6 },
    { prefix: "PE13", zone: 6 },
    { prefix: "PE14", zone: 6 },
    { prefix: "PE15", zone: 6 },
    { prefix: "PE16", zone: 6 },
    { prefix: "PE19", zone: 4 },
    { prefix: "PE2", zone: 4 },
    { prefix: "PE20", zone: 5 },
    { prefix: "PE21", zone: 5 },
    { prefix: "PE22", zone: 6 },
    { prefix: "PE23", zone: 6 },
    { prefix: "PE24", zone: 6 },
    { prefix: "PE25", zone: 6 },
    { prefix: "PE26", zone: 4 },
    { prefix: "PE27", zone: 4 },
    { prefix: "PE28", zone: 4 },
    { prefix: "PE29", zone: 4 },
    { prefix: "PE3", zone: 4 },
    { prefix: "PE30", zone: 6 },
    { prefix: "PE31", zone: 6 },
    { prefix: "PE32", zone: 6 },
    { prefix: "PE33", zone: 6 },
    { prefix: "PE34", zone: 6 },
    { prefix: "PE35", zone: 6 },
    { prefix: "PE36", zone: 6 },
    { prefix: "PE37", zone: 6 },
    { prefix: "PE38", zone: 6 },
    { prefix: "PE4", zone: 4 },
    { prefix: "PE5", zone: 4 },
    { prefix: "PE6", zone: 4 },
    { prefix: "PE7", zone: 4 },
    { prefix: "PE8", zone: 3 },
    { prefix: "PE9", zone: 3 },
    { prefix: "PH1", zone: 10 },
    { prefix: "PH10", zone: 11 },
    { prefix: "PH11", zone: 10 },
    { prefix: "PH12", zone: 10 },
    { prefix: "PH13", zone: 10 },
    { prefix: "PH14", zone: 10 },
    { prefix: "PH15", zone: 11 },
    { prefix: "PH16", zone: 11 },
    { prefix: "PH17", zone: 11 },
    { prefix: "PH18", zone: 11 },
    { prefix: "PH19", zone: 12 },
    { prefix: "PH2", zone: 10 },
    { prefix: "PH20", zone: 12 },
    { prefix: "PH21", zone: 12 },
    { prefix: "PH22", zone: 12 },
    { prefix: "PH23", zone: 12 },
    { prefix: "PH24", zone: 12 },
    { prefix: "PH25", zone: 12 },
    { prefix: "PH26", zone: 12 },
    { prefix: "PH3", zone: 10 },
    { prefix: "PH30", zone: 12 },
    { prefix: "PH31", zone: 12 },
    { prefix: "PH32", zone: 12 },
    { prefix: "PH33", zone: 12 },
    { prefix: "PH34", zone: 12 },
    { prefix: "PH35", zone: 12 },
    { prefix: "PH36", zone: 12 },
    { prefix: "PH37", zone: 12 },
    { prefix: "PH38", zone: 12 },
    { prefix: "PH39", zone: 12 },
    { prefix: "PH4", zone: 10 },
    { prefix: "PH40", zone: 12 },
    { prefix: "PH41", zone: 12 },
    { prefix: "PH42", zone: 24 },
    { prefix: "PH43", zone: 24 },
    { prefix: "PH44", zone: 24 },
    { prefix: "PH49", zone: 12 },
    { prefix: "PH5", zone: 10 },
    { prefix: "PH50", zone: 12 },
    { prefix: "PH6", zone: 10 },
    { prefix: "PH7", zone: 10 },
    { prefix: "PH8", zone: 11 },
    { prefix: "PH9", zone: 11 },
    { prefix: "PL", zone: 9 },
    { prefix: "PO1", zone: 7 },
    { prefix: "PO10", zone: 7 },
    { prefix: "PO11", zone: 7 },
    { prefix: "PO12", zone: 7 },
    { prefix: "PO13", zone: 7 },
    { prefix: "PO14", zone: 7 },
    { prefix: "PO15", zone: 7 },
    { prefix: "PO16", zone: 7 },
    { prefix: "PO17", zone: 7 },
    { prefix: "PO18", zone: 7 },
    { prefix: "PO19", zone: 7 },
    { prefix: "PO2", zone: 7 },
    { prefix: "PO20", zone: 7 },
    { prefix: "PO21", zone: 7 },
    { prefix: "PO22", zone: 7 },
    { prefix: "PO3", zone: 7 },
    { prefix: "PO30", zone: 25 },
    { prefix: "PO31", zone: 25 },
    { prefix: "PO32", zone: 25 },
    { prefix: "PO33", zone: 25 },
    { prefix: "PO34", zone: 25 },
    { prefix: "PO35", zone: 25 },
    { prefix: "PO36", zone: 25 },
    { prefix: "PO37", zone: 25 },
    { prefix: "PO38", zone: 25 },
    { prefix: "PO39", zone: 25 },
    { prefix: "PO4", zone: 7 },
    { prefix: "PO40", zone: 25 },
    { prefix: "PO41", zone: 25 },
    { prefix: "PO5", zone: 7 },
    { prefix: "PO6", zone: 7 },
    { prefix: "PO7", zone: 7 },
    { prefix: "PO8", zone: 7 },
    { prefix: "PO9", zone: 7 },
    { prefix: "PR", zone: 32 },
    { prefix: "RG", zone: 7 },
    { prefix: "RH", zone: 8 },
    { prefix: "RM1", zone: 13 },
    { prefix: "RM10", zone: 13 },
    { prefix: "RM11", zone: 13 },
    { prefix: "RM12", zone: 13 },
    { prefix: "RM13", zone: 13 },
    { prefix: "RM14", zone: 13 },
    { prefix: "RM15", zone: 7 },
    { prefix: "RM16", zone: 7 },
    { prefix: "RM17", zone: 7 },
    { prefix: "RM18", zone: 7 },
    { prefix: "RM19", zone: 13 },
    { prefix: "RM2", zone: 13 },
    { prefix: "RM20", zone: 7 },
    { prefix: "RM3", zone: 13 },
    { prefix: "RM4", zone: 13 },
    { prefix: "RM5", zone: 13 },
    { prefix: "RM6", zone: 13 },
    { prefix: "RM7", zone: 13 },
    { prefix: "RM8", zone: 13 },
    { prefix: "RM9", zone: 13 },
    { prefix: "S1", zone: 32 },
    { prefix: "SA1", zone: 8 },
    { prefix: "SA10", zone: 8 },
    { prefix: "SA11", zone: 8 },
    { prefix: "SA12", zone: 8 },
    { prefix: "SA13", zone: 8 },
    { prefix: "SA14", zone: 8 },
    { prefix: "SA15", zone: 8 },
    { prefix: "SA16", zone: 8 },
    { prefix: "SA17", zone: 8 },
    { prefix: "SA18", zone: 8 },
    { prefix: "SA19", zone: 9 },
    { prefix: "SA2", zone: 8 },
    { prefix: "SA20", zone: 9 },
    { prefix: "SA3", zone: 8 },
    { prefix: "SA31", zone: 9 },
    { prefix: "SA32", zone: 9 },
    { prefix: "SA33", zone: 9 },
    { prefix: "SA34", zone: 9 },
    { prefix: "SA35", zone: 9 },
    { prefix: "SA36", zone: 9 },
    { prefix: "SA37", zone: 9 },
    { prefix: "SA38", zone: 9 },
    { prefix: "SA39", zone: 9 },
    { prefix: "SA4", zone: 8 },
    { prefix: "SA40", zone: 9 },
    { prefix: "SA41", zone: 9 },
    { prefix: "SA42", zone: 9 },
    { prefix: "SA43", zone: 9 },
    { prefix: "SA44", zone: 9 },
    { prefix: "SA45", zone: 9 },
    { prefix: "SA46", zone: 9 },
    { prefix: "SA47", zone: 9 },
    { prefix: "SA48", zone: 9 },
    { prefix: "SA5", zone: 8 },
    { prefix: "SA6", zone: 8 },
    { prefix: "SA61", zone: 9 },
    { prefix: "SA62", zone: 9 },
    { prefix: "SA63", zone: 9 },
    { prefix: "SA64", zone: 9 },
    { prefix: "SA65", zone: 9 },
    { prefix: "SA66", zone: 9 },
    { prefix: "SA67", zone: 9 },
    { prefix: "SA68", zone: 9 },
    { prefix: "SA69", zone: 9 },
    { prefix: "SA7", zone: 8 },
    { prefix: "SA70", zone: 9 },
    { prefix: "SA71", zone: 9 },
    { prefix: "SA72", zone: 9 },
    { prefix: "SA73", zone: 9 },
    { prefix: "SA8", zone: 8 },
    { prefix: "SA80", zone: 8 },
    { prefix: "SA9", zone: 8 },
    { prefix: "SA99", zone: 8 },
    { prefix: "SE1", zone: 30 },
    { prefix: "SE10", zone: 29 },
    { prefix: "SE11", zone: 30 },
    { prefix: "SE12", zone: 13 },
    { prefix: "SE13", zone: 29 },
    { prefix: "SE14", zone: 29 },
    { prefix: "SE15", zone: 29 },
    { prefix: "SE16", zone: 30 },
    { prefix: "SE17", zone: 30 },
    { prefix: "SE18", zone: 13 },
    { prefix: "SE19", zone: 29 },
    { prefix: "SE2", zone: 13 },
    { prefix: "SE20", zone: 29 },
    { prefix: "SE21", zone: 29 },
    { prefix: "SE22", zone: 29 },
    { prefix: "SE23", zone: 29 },
    { prefix: "SE24", zone: 29 },
    { prefix: "SE25", zone: 13 },
    { prefix: "SE26", zone: 29 },
    { prefix: "SE27", zone: 29 },
    { prefix: "SE28", zone: 13 },
    { prefix: "SE3", zone: 29 },
    { prefix: "SE4", zone: 29 },
    { prefix: "SE5", zone: 29 },
    { prefix: "SE6", zone: 13 },
    { prefix: "SE7", zone: 29 },
    { prefix: "SE8", zone: 29 },
    { prefix: "SE9", zone: 13 },
    { prefix: "SG", zone: 7 },
    { prefix: "SK1", zone: 3 },
    { prefix: "SK10", zone: 3 },
    { prefix: "SK11", zone: 3 },
    { prefix: "SK12", zone: 4 },
    { prefix: "SK13", zone: 4 },
    { prefix: "SK14", zone: 3 },
    { prefix: "SK15", zone: 3 },
    { prefix: "SK16", zone: 3 },
    { prefix: "SK17", zone: 4 },
    { prefix: "SK2", zone: 4 },
    { prefix: "SK22", zone: 4 },
    { prefix: "SK23", zone: 4 },
    { prefix: "SK3", zone: 3 },
    { prefix: "SK4", zone: 3 },
    { prefix: "SK5", zone: 3 },
    { prefix: "SK6", zone: 4 },
    { prefix: "SK7", zone: 3 },
    { prefix: "SK8", zone: 3 },
    { prefix: "SK9", zone: 3 },
    { prefix: "SL", zone: 14 },
    { prefix: "SM", zone: 13 },
    { prefix: "SN", zone: 17 },
    { prefix: "SO", zone: 7 },
    { prefix: "SP", zone: 7 },
    { prefix: "SR", zone: 34 },
    { prefix: "SS", zone: 7 },
    { prefix: "ST", zone: 3 },
    { prefix: "SW10", zone: 29 },
    { prefix: "SW11", zone: 29 },
    { prefix: "SW12", zone: 29 },
    { prefix: "SW13", zone: 29 },
    { prefix: "SW14", zone: 29 },
    { prefix: "SW15", zone: 29 },
    { prefix: "SW16", zone: 29 },
    { prefix: "SW17", zone: 29 },
    { prefix: "SW18", zone: 29 },
    { prefix: "SW19", zone: 29 },
    { prefix: "SW1", zone: 30 },
    { prefix: "SW2", zone: 29 },
    { prefix: "SW20", zone: 29 },
    { prefix: "SW3", zone: 29 },
    { prefix: "SW4", zone: 29 },
    { prefix: "SW5", zone: 29 },
    { prefix: "SW6", zone: 29 },
    { prefix: "SW7", zone: 29 },
    { prefix: "SW8", zone: 29 },
    { prefix: "SW9", zone: 29 },
    { prefix: "SW95", zone: 29 },
    { prefix: "SY1", zone: 4 },
    { prefix: "SY10", zone: 9 },
    { prefix: "SY11", zone: 9 },
    { prefix: "SY12", zone: 5 },
    { prefix: "SY13", zone: 4 },
    { prefix: "SY14", zone: 4 },
    { prefix: "SY15", zone: 9 },
    { prefix: "SY16", zone: 9 },
    { prefix: "SY17", zone: 9 },
    { prefix: "SY18", zone: 9 },
    { prefix: "SY19", zone: 9 },
    { prefix: "SY2", zone: 4 },
    { prefix: "SY20", zone: 9 },
    { prefix: "SY21", zone: 9 },
    { prefix: "SY22", zone: 9 },
    { prefix: "SY23", zone: 9 },
    { prefix: "SY24", zone: 9 },
    { prefix: "SY25", zone: 9 },
    { prefix: "SY3", zone: 4 },
    { prefix: "SY4", zone: 4 },
    { prefix: "SY5", zone: 4 },
    { prefix: "SY6", zone: 4 },
    { prefix: "SY7", zone: 6 },
    { prefix: "SY8", zone: 6 },
    { prefix: "SY9", zone: 6 },
    { prefix: "SY99", zone: 4 },
    { prefix: "TA", zone: 8 },
    { prefix: "TD1", zone: 9 },
    { prefix: "TD10", zone: 10 },
    { prefix: "TD11", zone: 10 },
    { prefix: "TD12", zone: 10 },
    { prefix: "TD13", zone: 10 },
    { prefix: "TD14", zone: 10 },
    { prefix: "TD15", zone: 10 },
    { prefix: "TD2", zone: 9 },
    { prefix: "TD3", zone: 10 },
    { prefix: "TD4", zone: 9 },
    { prefix: "TD5", zone: 10 },
    { prefix: "TD6", zone: 10 },
    { prefix: "TD7", zone: 10 },
    { prefix: "TD8", zone: 10 },
    { prefix: "TD9", zone: 10 },
    { prefix: "TF", zone: 3 },
    { prefix: "TN1", zone: 7 },
    { prefix: "TN10", zone: 7 },
    { prefix: "TN11", zone: 7 },
    { prefix: "TN12", zone: 7 },
    { prefix: "TN13", zone: 8 },
    { prefix: "TN14", zone: 7 },
    { prefix: "TN15", zone: 7 },
    { prefix: "TN16", zone: 7 },
    { prefix: "TN17", zone: 7 },
    { prefix: "TN18", zone: 7 },
    { prefix: "TN19", zone: 8 },
    { prefix: "TN2", zone: 7 },
    { prefix: "TN20", zone: 8 },
    { prefix: "TN21", zone: 8 },
    { prefix: "TN22", zone: 8 },
    { prefix: "TN23", zone: 7 },
    { prefix: "TN24", zone: 7 },
    { prefix: "TN25", zone: 7 },
    { prefix: "TN26", zone: 8 },
    { prefix: "TN27", zone: 8 },
    { prefix: "TN28", zone: 8 },
    { prefix: "TN29", zone: 8 },
    { prefix: "TN3", zone: 7 },
    { prefix: "TN30", zone: 8 },
    { prefix: "TN31", zone: 8 },
    { prefix: "TN32", zone: 8 },
    { prefix: "TN33", zone: 8 },
    { prefix: "TN34", zone: 8 },
    { prefix: "TN35", zone: 8 },
    { prefix: "TN36", zone: 8 },
    { prefix: "TN37", zone: 8 },
    { prefix: "TN38", zone: 8 },
    { prefix: "TN39", zone: 8 },
    { prefix: "TN4", zone: 7 },
    { prefix: "TN40", zone: 8 },
    { prefix: "TN5", zone: 7 },
    { prefix: "TN6", zone: 8 },
    { prefix: "TN7", zone: 8 },
    { prefix: "TN8", zone: 8 },
    { prefix: "TN9", zone: 7 },
    { prefix: "TQ", zone: 9 },
    { prefix: "TR1", zone: 9 },
    { prefix: "TR10", zone: 10 },
    { prefix: "TR11", zone: 10 },
    { prefix: "TR12", zone: 10 },
    { prefix: "TR13", zone: 10 },
    { prefix: "TR14", zone: 10 },
    { prefix: "TR15", zone: 10 },
    { prefix: "TR16", zone: 10 },
    { prefix: "TR17", zone: 10 },
    { prefix: "TR18", zone: 10 },
    { prefix: "TR19", zone: 10 },
    { prefix: "TR2", zone: 9 },
    { prefix: "TR20", zone: 10 },
    { prefix: "TR21", zone: 10 },
    { prefix: "TR22", zone: 10 },
    { prefix: "TR23", zone: 10 },
    { prefix: "TR24", zone: 10 },
    { prefix: "TR25", zone: 10 },
    { prefix: "TR26", zone: 10 },
    { prefix: "TR27", zone: 10 },
    { prefix: "TR3", zone: 9 },
    { prefix: "TR4", zone: 9 },
    { prefix: "TR5", zone: 9 },
    { prefix: "TR6", zone: 9 },
    { prefix: "TR7", zone: 9 },
    { prefix: "TR8", zone: 9 },
    { prefix: "TR9", zone: 9 },
    { prefix: "TS", zone: 34 },
    { prefix: "TW1", zone: 15 },
    { prefix: "TW10", zone: 15 },
    { prefix: "TW11", zone: 15 },
    { prefix: "TW12", zone: 15 },
    { prefix: "TW13", zone: 14 },
    { prefix: "TW14", zone: 14 },
    { prefix: "TW15", zone: 14 },
    { prefix: "TW16", zone: 14 },
    { prefix: "TW17", zone: 14 },
    { prefix: "TW18", zone: 14 },
    { prefix: "TW19", zone: 14 },
    { prefix: "TW2", zone: 15 },
    { prefix: "TW20", zone: 14 },
    { prefix: "TW3", zone: 14 },
    { prefix: "TW4", zone: 14 },
    { prefix: "TW5", zone: 14 },
    { prefix: "TW6", zone: 14 },
    { prefix: "TW7", zone: 14 },
    { prefix: "TW8", zone: 15 },
    { prefix: "TW9", zone: 15 },
    { prefix: "UB", zone: 14 },
    { prefix: "W10", zone: 29 },
    { prefix: "W11", zone: 29 },
    { prefix: "W12", zone: 15 },
    { prefix: "W13", zone: 15 },
    { prefix: "W14", zone: 29 },
    { prefix: "W1", zone: 30 },
    { prefix: "W2", zone: 29 },
    { prefix: "W3", zone: 15 },
    { prefix: "W4", zone: 15 },
    { prefix: "W5", zone: 15 },
    { prefix: "W6", zone: 29 },
    { prefix: "W7", zone: 15 },
    { prefix: "W8", zone: 29 },
    { prefix: "W9", zone: 29 },
    { prefix: "WA", zone: 32 },
    { prefix: "WC", zone: 30 },
    { prefix: "WD", zone: 7 },
    { prefix: "WF", zone: 2 },
    { prefix: "WN", zone: 32 },
    { prefix: "WR1", zone: 3 },
    { prefix: "WR10", zone: 5 },
    { prefix: "WR11", zone: 5 },
    { prefix: "WR12", zone: 5 },
    { prefix: "WR13", zone: 5 },
    { prefix: "WR14", zone: 5 },
    { prefix: "WR15", zone: 3 },
    { prefix: "WR2", zone: 3 },
    { prefix: "WR3", zone: 3 },
    { prefix: "WR4", zone: 3 },
    { prefix: "WR5", zone: 3 },
    { prefix: "WR6", zone: 3 },
    { prefix: "WR7", zone: 3 },
    { prefix: "WR8", zone: 5 },
    { prefix: "WR9", zone: 3 },
    { prefix: "WR99", zone: 3 },
    { prefix: "WS1", zone: 3 },
    { prefix: "WS10", zone: 3 },
    { prefix: "WS11", zone: 3 },
    { prefix: "WS12", zone: 3 },
    { prefix: "WS13", zone: 1 },
    { prefix: "WS14", zone: 3 },
    { prefix: "WS15", zone: 1 },
    { prefix: "WS2", zone: 3 },
    { prefix: "WS3", zone: 3 },
    { prefix: "WS4", zone: 3 },
    { prefix: "WS5", zone: 3 },
    { prefix: "WS6", zone: 3 },
    { prefix: "WS7", zone: 3 },
    { prefix: "WS8", zone: 3 },
    { prefix: "WS9", zone: 3 },
    { prefix: "WV", zone: 3 },
    { prefix: "YO1", zone: 33 },
    { prefix: "YO10", zone: 33 },
    { prefix: "YO11", zone: 35 },
    { prefix: "YO12", zone: 35 },
    { prefix: "YO13", zone: 35 },
    { prefix: "YO14", zone: 35 },
    { prefix: "YO15", zone: 35 },
    { prefix: "YO16", zone: 35 },
    { prefix: "YO17", zone: 35 },
    { prefix: "YO18", zone: 35 },
    { prefix: "YO19", zone: 33 },
    { prefix: "YO21", zone: 35 },
    { prefix: "YO22", zone: 35 },
    { prefix: "YO23", zone: 33 },
    { prefix: "YO24", zone: 33 },
    { prefix: "YO25", zone: 35 },
    { prefix: "YO26", zone: 33 },
    { prefix: "YO30", zone: 33 },
    { prefix: "YO31", zone: 33 },
    { prefix: "YO32", zone: 33 },
    { prefix: "YO41", zone: 35 },
    { prefix: "YO42", zone: 35 },
    { prefix: "YO43", zone: 33 },
    { prefix: "YO51", zone: 35 },
    { prefix: "YO60", zone: 35 },
    { prefix: "YO61", zone: 35 },
    { prefix: "YO62", zone: 34 },
    { prefix: "YO7", zone: 34 },
    { prefix: "YO8", zone: 33 },
    { prefix: "YO90", zone: 33 },
    { prefix: "ZE", zone: 22 },
];